module.exports = __webpack_public_path__ + "static/more-af9c0a3bc9beab9775b30b315272d53e.svg";